import React, { createContext, useContext, useRef } from 'react';

const MapContext = createContext({});

export function MapProvider({ children }) {
  const ref = useRef({}).current;

  return (
    <MapContext.Provider value={{ ref }}>
      {children}
    </MapContext.Provider>
  );
}

export function useMapContext() {
  const { ref } = useContext(MapContext);
  return { ref };
}



// WEBPACK FOOTER //
// ./src/containers/Places/components/Address/map.context.js